import { appState } from '@/store/appState'
import { Button } from '@/components/ui/Button'
import { GoogleMapSelectMode } from '@/components/GoogleMapSelectMode'
import { startGetingCurrentUserLocation } from '@/custom/startGetingCurrentUserLocation'
import { tr } from '@/i18n'

/* The `directions` view (actions_bottom_sheet_widget.dart:477-678).
 *
 * The original wraps the mode switch in an InkWell whose onTap overwrites
 * walkingDirectionModel with {text:'3', value:11} — leftover DEBUG code that
 * wipes real route data. NOT ported (flags.PARITY_DEBUG_INKWELL).
 *
 * "Go back": view -> initial WITH update() (this one publishes), then
 * startGetingCurrentUserLocation(true) — the only place the geolocation
 * timer is ever cancelled. */

interface Props {
  send: (delayMs: 2000 | 1000) => Promise<void>
}

export function DirectionsView({ send }: Props) {
  return (
    <>
      {/* Padding(14,22,14,0) — debug InkWell intentionally omitted */}
      <div style={{ width: '100%', padding: '22px 14px 0' }}>
        <GoogleMapSelectMode />
      </div>

      {/* Padding(0,20,0,0) — 1000 ms post-success delay here (vs 2000) */}
      <div style={{ paddingTop: 20 }}>
        <Button text={tr.sheet.sendReassurance} onClick={() => send(1000)} />
      </div>

      {/* Padding(0,12,0,30) */}
      <div style={{ padding: '12px 0 30px' }}>
        <Button
          text={tr.sheet.goBack}
          variant="outlinedLight"
          onClick={async () => {
            appState.currentBottomSheetView = 'initial'
            appState.update() // publishes — map reacts (didUpdateWidget ELSE)
            await startGetingCurrentUserLocation(true) // stop the timer
          }}
        />
      </div>
    </>
  )
}
